import { render, staticRenderFns } from "./ToggleSwitchControl.vue?vue&type=template&id=c186964e&"
import script from "./ToggleSwitchControl.vue?vue&type=script&lang=ts&"
export * from "./ToggleSwitchControl.vue?vue&type=script&lang=ts&"
import style0 from "./ToggleSwitchControl.vue?vue&type=style&index=0&id=c186964e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports